<script>
    export default {
        name: '',
        props: {
            data: {
                required: false,
                default: () => ({})
            }
        },
        data () {
            return {};
        },
        methods: {},
        components: {},
        mounted () {
        }
    };
</script>

<template>
    <div class="post-item">
        <a :href="data.url" class="post-item__title">{{ data.title}}</a>
        <div v-if="data.subtitle" class="post-item__subtitle">{{data.subtitle }}</div>
        <div v-if="data.short_title" class="post-item__shorttitle">{{data.short_title }}</div>
        <!-- <div v-if="data.abstract" class="post-item__abstract">{{ data.abstract }}<a :href="data.url" class="with-link">查看全文>></a>
        </div> -->
        <div v-if="data.abstract" v-html="data.abstract" class="post-item__abstract"></div>
        <div class="post-item__date">
            {{data.visible_publish_time | date}}
        </div>
    </div>

</template>

<style lang="less" scoped>
    .post-item {
        border: 1px solid @otherGreyBgClr;
        .px2rem(padding-top, 42);
        .px2rem(padding-left, 38);
        .px2rem(padding-bottom, 28);
        .px2rem(padding-right, 38);
        .px2rem(margin-bottom, 48);
        border-radius: 8px;
        line-height: 1.8;
        text-align: justify;
        &__title {
            text-align: center;
            color: @otherNormalTitleClr;
            .px2rem(font-size, 32);
            margin: 0;
            font-weight: bold;
            display: block;
        }

        &__subtitle {
            color: @primaryBg;
            .px2rem(font-size, 28);
            font-weight: bold;
            .px2rem(padding-top, 48);
        }

        &__shorttitle {
            .px2rem(font-size, 28);
            color: @otherTextClr;
            .px2rem(padding-top, 28);
        }

        &__abstract {
            .px2rem(margin-top, 28);
            background: #f0f0f0;
            .px2rem(font-size, 28);
            border-radius: 8px;
            .px2rem(padding-top, 39);
            .px2rem(padding-left, 33);
            .px2rem(padding-bottom, 39);
            .px2rem(padding-right, 33);
            color: @otherTextClr;
            .px2rem(padding-top, 28);

            .with-link {
                color: @primaryBg;
                text-underline: none;
            }
        }

        &__date {
            text-align: right;
            color: @otherBtnBorderNoteClr;
            .px2rem(font-size, 28);
            .px2rem(margin-top, 28);
        }
    }

</style>
